import PackLearnConfig from './packLearnConfig.es6'

export default class PackReviewConfig extends PackLearnConfig {
    constructor(opts) {
        super(opts);
    }

    saveConfig() {
        // do nothing
    }

    resetProgress() {
        // do nothing
    }
}